export interface BlogCategoryFormValues {
  name: string
  path: string
  description: string
  seoTitle: string
  seoDescription: string
}

export enum BlogCategoryFormModeEnum {
  Create = 'create',
  Edit = 'edit',
}
